import React from 'react';


import Filterable from '@components/Filterable/Filterable';
import TabsList from './TabsList';
import { tabsSet, FILTERS } from './constants';

/*
  Presentational component for Tabs
*/

const Tabs = () => (
  <Filterable
    customClasses={'main-content'}
    filters={FILTERS}
    data={tabsSet}
    withoutSearch
  >
    <TabsList/>
  </Filterable>
);

Tabs.displayName = 'TabsPage';

export default Tabs;




// WEBPACK FOOTER //
// ./src/containers/elements/Tabs/Tabs.js